export const getSessionFilters = () => {
  let filters = JSON.parse(sessionStorage.getItem('filters'))
  /* Workaround for changing search field */
  if (filters?.search) {
    if (filters.search === "") {
      delete filters.search
    }
  }
}

export const saveSessionFilters = (selectedFilters) => {
  sessionStorage.setItem('filters', JSON.stringify(selectedFilters))
}

export const removeSessionFilters = () => {
  sessionStorage.removeItem('filters')
}
